import {
  Gauge, ChatsCircle, Brain, BookBookmark, FileArrowUp, Books, Megaphone, Database, Storefront, MapTrifold, Package, Tray,
  ShieldCheck, Lock, WarningCircle, Image as ImageIcon, VideoCamera, SlidersHorizontal, Factory, Tire, Ruler, Lifebuoy,
  GraduationCap, Archive, Van, Wrench, Handshake, GearSix,
} from "@phosphor-icons/react";

// `tid` keeps the original data-testid for items that were renamed.
export const TOP_NAV = [
  { to: "/admin", label: "Dashboard", icon: Gauge, end: true },
  { to: "/admin/conversations", label: "Conversations", icon: ChatsCircle },
  { to: "/admin/support-tickets", label: "Support Tickets", icon: Lifebuoy },
  { to: "/admin/discrepancies", label: "Config Discrepancies", icon: WarningCircle },
];

export const NAV_GROUPS = [
  { key: "ai-training", label: "AI Training", icon: GraduationCap, items: [
    { to: "/admin/feedback", label: "AI Feedback", icon: Brain },
    { to: "/admin/knowledge", label: "Knowledge Entries", icon: BookBookmark },
  ] },
  { key: "data-library", label: "Data Library", icon: Archive, items: [
    { to: "/admin/documents", label: "Documents", icon: FileArrowUp },
    { to: "/admin/manuals", label: "User Manuals", icon: Books },
    { to: "/admin/service-bulletins", label: "Service Bulletins", icon: Megaphone },
    { to: "/admin/videos", label: "Videos", icon: VideoCamera },
  ] },
  { key: "caravan-data", label: "Caravan Data", icon: Van, items: [
    { to: "/admin/caravans", label: "Caravan Database", icon: Database },
    { to: "/admin/hub-types", label: "Hub Types", icon: Tire },
    { to: "/admin/model-specs", label: "Model Specs", icon: Ruler },
    { to: "/admin/production-sync", label: "Production Sync", icon: Factory },
  ] },
  { key: "repair-network", label: "Repair Network", icon: Wrench, items: [
    { to: "/admin/repairers", label: "Repairers", icon: MapTrifold, tid: "repair-network" },
    { to: "/admin/suppliers", label: "Suppliers", icon: Package },
    { to: "/admin/submissions", label: "Submissions", icon: Tray },
  ] },
  { key: "dealers-warranty", label: "Dealers & Warranty", icon: Handshake, items: [
    { to: "/admin/warranty-claims", label: "Warranty Claims", icon: ShieldCheck },
    { to: "/admin/dealer-portal", label: "Dealer Portal", icon: Lock },
    { to: "/admin/dealers", label: "Selling Dealers", icon: Storefront },
  ] },
  { key: "settings", label: "Settings", icon: GearSix, items: [
    { to: "/admin/settings", label: "General Settings", icon: SlidersHorizontal, tid: "settings" },
    { to: "/admin/model-photos", label: "Model Photos", icon: ImageIcon },
  ] },
];

export const slug = (item) => item.tid || item.label.toLowerCase().replace(/\s+/g, "-");

export const isActivePath = (pathname, item) =>
  item.end ? pathname === item.to : pathname === item.to || pathname.startsWith(`${item.to}/`);
